import { AccountVoiceIcon } from './AccountVoiceIcon';

/**
 * author: Google
 * id F1EEA910-2CD7-448A-A12F-A1BD0FDC6010
 * name account-voice
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-voice.svg
 * tags
 * - Account / User 
 */
export const TalkIcon = AccountVoiceIcon;
export default TalkIcon